<template>
  <div v-if="order" class="pb-16">
    <v-overlay v-model="loadingOverlay" color="rgba(255, 255, 255, 0.85)" opacity="0.85" z-index="7" light>
      <div class="flower-spinner ma-auto">
        <div class="dots-container">
          <div class="bigger-dot">
            <div class="smaller-dot"></div>
          </div>
        </div>
      </div>

      <div class="black--text text-center mt-5">
        <span class="text-h6 font-weight-bold">{{
          processingCC
            ? $t("order_step_3_creditcard_auth_text")
            : $t("order_step_3_order_dealing")
        }}<br /><span v-html="$t('order_step_3_plz_waiting')"></span></span><br />
        Your order’s being processed.<br />
        Please wait patiently and don’t refresh this page.

        <div v-if="processingCC && cc3DUrl !== ''" class="grey lighten-1 px-8 py-2 mt-10">
          {{ $t("order_step_3_click_to_outer_link") }}
          <a :href="cc3DUrl" target="_blank" class="primary-1--text">{{
            $t("order_step_3_outer_link")
            }}</a>
        </div>
      </div>
    </v-overlay>
    <CustomPageHeaderVue class="flex-grow-0">{{
      $t("orderlist_title")
      }}</CustomPageHeaderVue>
    <CustomRow v-if="!isLoading" :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'mb-6' : ''">
      <v-card class="mt-5 py-3 px-4 cusPadding">
        <div class="text-center bg-tranparent-yellow pa-3 text-title font-weight-bold ">
          {{ $t("orderlist_payment") }}
        </div>

        <v-col cols="12" lg="8" md="8" :class="`mx-auto ${currentID === 'selectedPayWay' &&
          selectedPayWay.type === ''
          ? 'is-need-value'
          : ''
          }`
          " id="selectedPayWay">
          <v-radio-group v-model="selectedPayValue">
            <template v-for="(payWay, i) in payOption">
              <v-radio :value="payWay.type" color="primary" class="radioStyle pa-4" :class="{ 'mt-4': i !== 0 }"
                @change="selectPayWay(payWay.type)">
                <template slot="label">
                  <div v-if="payWay.type === 'CC'">
                    {{ $t("orderlist_card_payment_one_time") }}
                    <br />
                    <span class="text-eight">
                      {{ $t("order_step_3_cash_flow_provider") }}
                    </span>
                  </div>
                  <div v-if="payWay.type === 'ATM'">
                    <div class="d-flex align-center">
                      {{ $t("orderlist_virtual_account") }}
                      <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="primary" class="ml-1" v-bind="attrs" v-on="on"
                            dense>mdi-information-outline</v-icon>
                        </template>
                        <ul class="py-2 text-nine">
                          <li>{{ $t("order_step_3_atm_transfer_note_1") }}</li>
                          <li class="py-2">
                            {{ $t("order_step_3_atm_transfer_note_2") }}
                          </li>
                          <li class="pb-2">
                            {{ $t("order_step_3_atm_transfer_note_3") }}
                          </li>
                          <li>{{ $t("order_step_3_atm_transfer_note_4") }}</li>
                        </ul>
                      </v-tooltip>
                    </div>
                    <div class="text-eight">
                      <ul>
                        <li>{{
                          $t("order_step_3_atm_transfer_expired_lottery", {
                            lotteryDeadline: new Date(campaign.lotteryDeadline).toLocaleString() || ""
                          }) }} </li>
                        <li>{{
                          $t("foreigner_not_suppose_payment") }}</li>
                      </ul>
                    </div>
                  </div>
                </template>
              </v-radio>
              <div class="grey-1 pa-5" :key="payWay.type" v-if="payWay.type == 'CC' && selectedPayWay.type == 'CC'">
                <template v-if="loadingCCList">
                  <div class="text-center">
                    <v-progress-circular indeterminate color="primary-1" size="25" width="2"></v-progress-circular>
                  </div>
                </template>
                <template v-else>
                  <template v-if="loadCCFailed">
                    <v-btn dark rounded depressed color="light-blue" @click="selectPayWay('CC')">
                      <v-icon>mdi-replay</v-icon>
                      {{ $t("session_table_retry") }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <div id="add-credit-card" :class="{
                      'px-4': $vuetify.breakpoint.xs,
                      'px-8': !$vuetify.breakpoint.xs,
                      'pink-1 py-2': currentID === 'add-credit-card'
                    }" class="d-flex align-center text-nine">
                      <div v-if="!ccList.length" @click="updateCCInfo()" class="cursor-pointer">
                        <v-icon class="mr-1" dense>mdi-plus</v-icon>
                        {{ $t("creditcard_add_new_card") }}
                      </div>
                      <template v-else>
                        <div>
                          <div class="font-weight-bold">
                            {{
                              ccList.find(c => c.isDefault == "Y").issueBankName
                            }}
                          </div>
                          <div style="color: #8d8d8d">
                            {{ ccList.find(c => c.isDefault == "Y").mchd }}
                          </div>
                        </div>
                        <v-spacer />
                        <div class="
                              primary-1--text
                              cursor-pointer
                              font-weight-bold
                            " @click="updateCCInfo()">
                          {{ $t("order_step_3_change_creditcard") }}
                        </div>
                      </template>
                    </div>
                    <div class="red--text mt-3">
                      {{ $t("creditcard_add_new_card_tip") }}
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </v-radio-group>
        </v-col>
      </v-card>
      <v-card class="mt-5 py-3 px-4 ">
        <TicketTable :thead="thead" :tickets="order.tickets" :discount="order.discount || 0" :order="order"
          :isShippingFee="order && order.shippingType == 'post'">
          <template slot="title">{{ $t("orderlist_overview") }}</template>
        </TicketTable>
        <template v-if="!isLoading && campaign && campaign.recaptchaEnable">
          <div :class="`mt-3 d-flex justify-end ${isSubmit && !token ? 'is-need-value' : ''
            }`
            " id="recaptcha">
            <recaptcha ref="recaptcha" :siteKey="siteKey" @verify="verifyMethod" />
          </div>
        </template>
      </v-card>
    </CustomRow>

    <div class="order-footer">
      <CustomRow>
        <v-row no-gutters class="py-3 align-center">
          <v-col cols="6" class="d-flex flex-column flex-md-row">
            <template>
              <span class="text-nine">{{
                $t("order_step_3_total_price")
                }}</span>
              <span v-if="$vuetify.breakpoint.xs" class="primary-1--text ml-1">
                <h2>
                  NT.
                  {{
                    order.totalAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                </h2>
              </span>
              <div v-else class="ml-3 align-self-start primary-1--text">
                <h2>
                  NT.
                  {{
                    order.totalAmount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                </h2>
              </div>
            </template>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn class="nextBtn" depressed large @click="beforePay"
              :width="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 100 : 210">
              {{ $t('lottery_payment') }}
            </v-btn>
          </v-col>
        </v-row>
      </CustomRow>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CC from "@/api/config-center";
import OM from "@/api/order-management";
import { getEvent, getSessions } from "@/api/static";
import TicketTable from "@/views/order/components/TicketsTable";
import { CurrentReservedMixins } from "@/shared/mixins";
import Recaptcha from "@/components/Recaptcha";
import CustomPageHeaderVue from "@/components/CustomPageHeader.vue";
import { encrypt } from "@/vendor/crypto";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' // dependent on utc plugin

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("Asia/Taipei")

export default {
  name: "OrderedPayment",
  components: {
    TicketTable,
    CustomPageHeaderVue,
    Recaptcha
  },
  data() {
    return {
      abortController: new AbortController(),
      contentHeight: window.innerHeight - 420,
      isLoading: true,
      isAbort: false,
      loadingOverlay: false,
      loadCCFailed: false,
      processingCC: false,
      isOrderSuccessed: false,
      isSubmit: false,
      areaAssignmen: false,
      seatAssignmen: false,
      campaign: null,
      session: null,
      currentID: "",
      selectedPayValue: "",
      token: "",
      order: null,
      loadingCCList: false,
      ccList: [],
      payWays: [
        {
          type: "CC"
        },
        {
          type: "ATM"
        }
      ],
      selectedPayWay: { type: "" }
    };
  },
  computed: {
    canNextStep() {
      return !!this.isPaySelect
    },
    payOption() {
      let payways = !['', 'UNASSIGNED'].includes(this.order.transType) ? this.payWays.filter(p => p.type === this.order.transType) : this.payWays;
      return this.campaign ? payways.filter(payWay =>
        this.campaign.payment.includes(payWay.type)
      ) : [];
    },
    isPaySelect() {
      if (!this.payWays.length) return true;
      else {
        if (this.selectedPayWay.type == "CC")
          return this.ccList.length && this.selectedPayWay.type;
        return this.selectedPayWay.type;
      }
    },
    thead() {
      const defaultHead = [
        {
          name: "productName",
          label: this.$t(`orderlist_product_name`),
          col: this.areaAssignment && !this.seatAssignment ? 3 : 5,
          class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
        },
        {
          name: "count",
          label: this.$t(`orderlist_product_count`),
          col: 2,
          class: this.$vuetify.breakpoint.xs ? "text-right pr-4" : "text-center"
        },
        {
          name: "price",
          label: this.$t("order_step_2_product_price"),
          col: this.areaAssignment && !this.seatAssignment ? 2 : 3,
          class: this.$vuetify.breakpoint.xs ? "pl-4 mt-2" : "text-center"
        },
        {
          name: "sum",
          label: this.$t("orderlist_product_sum"),
          col: 2,
          class: this.$vuetify.breakpoint.xs
            ? "text-right pr-4 mt-2"
            : "text-center"
        }
      ];
      return this.order.tickets[0].ticketAreaName &&
        this.order.tickets[0].seatInfo
        ? [
          {
            name: "ticketAreaName",
            label: this.$t(`orderlist_ticketarea_name`),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
          },
          {
            name: "seat",
            label: this.$t("orderlist_ticketarea_seat"),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs
              ? "text-right pr-4"
              : "text-center"
          },
          {
            name: "productName",
            label: this.$t("orderlist_product_name"),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs ? "pl-4 mt-4" : "text-center"
          },
          {
            name: "price",
            label: this.$t("orderlist_product_sum"),
            col: 6,
            colSm: 3,
            class: this.$vuetify.breakpoint.xs
              ? "text-right pr-4 mt-4"
              : "text-center"
          }
        ]
        : this.order.tickets[0].ticketAreaName &&
          !this.order.tickets[0].seatInfo
          ? [
            {
              name: "ticketAreaName",
              label: this.$t("orderlist_ticketarea_name"),
              col: 12,
              colSm: 3,
              class: this.$vuetify.breakpoint.xs ? "pl-4" : "px-8"
            },
            ...defaultHead
          ]
          : defaultHead;
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setRecaptchaStatus: "user/setRecaptchaStatus"
    }),
    async timeout(timer = 5000) {
      return new Promise(resolve => {
        setTimeout(resolve, timer);
      });
    },
    orderSuccessed() {
      this.isSubmit = false;
      this.isOrderSuccessed = true;
      this.$router.push({
        name: "OrderedComplete",
        params: { orderId: this.order.orderId }
      }).catch(() => { });
    },
    orderFailed() {
      this.isSubmit = false;
      this.loadingOverlay = false;
      this.showDialog({
        alert: true,
        content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('order_step_3_order_fail')}</div>
          </div>`
      });
      setTimeout(() => {
        this.$router.push({
          name: "OrderList",
        }).catch(() => { });
      }, 3000);
    },
    async apiGetOrderInfo() {
      if (this.isAbort) return;
      let { data: getOrderInfoRes } = await OM.getOrderInfo(
        this.order.orderId, this.abortController
      );
      console.log(
        `${String.fromCodePoint(128049)} [OM] getOrderInfo`,
        getOrderInfoRes
      );
      if (getOrderInfoRes.errCode == "00") {
        // ATM && atmAccount
        if (getOrderInfoRes.atmAccount) {
          this.orderSuccessed();
        } else if (getOrderInfoRes.txStatus === "SUCCESS") {
          this.loadingOverlay = false;
          this.orderSuccessed();
        } else if (getOrderInfoRes.txStatus === "FAILED") {
          console.error("getOrderInfo failed");
          this.orderFailed();
        } else if (
          (getOrderInfoRes.transType === '' || getOrderInfoRes.txStatus === '') ||
          (
            this.selectedPayValue === "ATM" &&
            !getOrderInfoRes.atmAccount
          )
        ) {
          return setTimeout(() => this.apiGetOrderInfo(), 5000)
        } else return getOrderInfoRes;
        return false;
      } else {
        this.orderFailed();
        return false;
      }
    },
    async retryGetOrderInfo() {
      await this.timeout();
      if (this.isAbort) return;
      return await this.apiGetOrderInfo();
    },
    async get3dCCLink() {
      setTimeout(async () => {
        let result = await this.apiGetOrderInfo();
        if (!!result) {
          while (result && result.txStatus === "WAITING" || result.txStatus === "3D") {
            result = await this.retryGetOrderInfo();
            if (
              !!result &&
              result.txStatus &&
              result.txStatus === "3D" &&
              !this.open3DTabLink &&
              !!result.cc3DUrl &&
              result.cc3DUrl !== ""
            ) {
              this.cc3DUrl = result.cc3DUrl;
              this.getcc3DUrl = true;
              this.showDialog({
                error: true,
                title: this.$t('order_step_3_cc_verify_title'),
                content: this.$t('order_step_3_cc_verify_content'),
                button: this.$t('layout_notification_confirm'),
                outerLink: result.cc3DUrl,
                action: () => {
                  this.open3DTabLink = true;
                }
              });
            }
            if (!this.getcc3DUrl) {
              this.get3dCCLink();
            }
          }
        }
      }, 3000); // 改成 3sec
    },
    beforePay() {
      if (this.payOption.length === 1 || this.order.isShowCCToCCRepayBtn) {
        this.pay()
      } else {
        this.showDialog({
          title: this.$t('ordered_payment_confirm_title'),
          content: this.$t('ordered_payment_confirm_content'),
          buttons: [
            {
              text: this.$t('layout_notification_cancel'),
              style: {
                block: true,
                outlined: true,
                color: "primary",
              },
              action() { }
            },
            {
              text: this.$t('layout_notification_confirm'),
              style: {
                depressed: true,
                block: true,
                outlined: false,
                color: "primary",
              },
              action: async () => {
                this.pay()
              },
            },
          ],
        })
      }
    },
    async pay() {
      let elem = null;
      if (!this.canNextStep) {
        if (this.payWays.length && (this.campaign.payment && !this.campaign.payment.includes('FREE')) && this.selectedPayWay.type === '') {
          this.currentID = 'selectedPayWay'
          elem = document.querySelector('#selectedPayWay')
        } else if (this.selectedPayWay.type === 'CC' && !this.ccList.length) {
          this.currentID = 'add-credit-card'
          elem = document.querySelector('#add-credit-card')
        }
        const rect = elem.getBoundingClientRect()
        // console.log(elem, window.scrollTop, elem.parentNode.offsetTop, rect)
        window.scrollTo({
          left: 0,
          top: elem ? window.scrollY + rect.top - 200 : document.body.clientHeight,
          behavior: 'smooth'
        })

        this.isSubmit = false
        return
      }
      this.isSubmit = true;
      this.loadingOverlay = true;
      const { data } = await OM.paymentProcess({
        orderNum: this.order.orderNum,
        transType: this.selectedPayValue,
        isRepay: Boolean(this.$route.query?.repay)
      })
      if (data.errCode === '00') {
        if (this.selectedPayValue === "CC") {
          this.processingCC = true;
          this.get3dCCLink();
        } else {
          this.orderSuccessed();
        }
      } else {
        this.orderFailed();
      }
    },
    verifyMethod(response) {
      this.token = response;
    },
    async getSessionInfo(sessionData, sessionInfo) {
      this.session = {
        ...sessionData,
        ...sessionInfo[0]
      };
      this.$store.dispatch("setOverlayLoading", false);
    },
    async init() {
      const { data } = await OM.getAllOrders(this.$route.params.orderNum);
      if (data.errCode == "00") {
        this.order = {
          ...data.data[0],
          tickets: data.data[0].tickets.map(t => ({
            ...t,
            seat: t.seatInfo.seat,
          }))
        };
        if ((!this.order.isShowPaymentBtn && !this.order.isShowCCToCCRepayBtn) || this.order.payStatus === '已付款') {
          this.$router.push({
            name: 'OrderList'
          })
        } else {
          this.initInfo();
        }
      }
    },
    async initInfo() {
      const { data: eventsData } = await getEvent(encrypt(this.order.eventId));
      const { data: sessionData } = await getSessions(
        encrypt(this.order.eventId)
      );

      let [{ data: infoData }, getInfosErr] = await CC.getInfos({
        eventId: [encrypt(this.order.eventId)],
        sessionId: [encrypt(this.order.sessionId)]
      });
      if (infoData.errCode == "00") {
        this.campaign = { ...eventsData, ...infoData.result.event[0] };
        await this.getSessionInfo(
          sessionData.sessions.find(({ sessionId }) => {
            let sid = /^s[0-9]{9}$/.test(sessionId)
              ? encrypt(sessionId)
              : sessionId;
            return sid == this.$route.params.sessionId;
          }),
          infoData.result.session
        );
        this.isLoading = false;
      }
    },
    selectPayWay(type) {
      if (type === "CC") {
        this.getUserCCInfo();
      }
      if (type === "ATM") this.ccList = [];

      this.selectedPayWay.type = type;
    },
    async getUserCCInfo() {
      this.loadingCCList = true;
      this.$forceUpdate();
      const { data: getCCresponse } = await OM.getUserCCInfo();
      if (getCCresponse.errCode === "00") {
        this.ccList = getCCresponse.ccList;
      } else {
        this.loadCCFailed = true;
      }
      this.loadingCCList = false;
      this.$store.dispatch("setOverlayLoading", false);
      this.$forceUpdate();
    },
    async updateCCInfo() {
      if (!!window.win) window.open(window.winUrl, 'credit-page')
      else {
        window.win = window.open("", 'credit-page');
        const { data: updateCCResponse } = await OM.updateCCInfo();
        if (updateCCResponse.errCode == "00" && updateCCResponse.url) {
          window.win.location = updateCCResponse.url;
          window.winUrl = updateCCResponse.url
          this.detectCloseInterval = setInterval(() => {
            if (!window.win || window.win.closed) {
              this.$store.dispatch("setOverlayLoading", true);
              window.win = null
              window.winUrl = null
              clearInterval(this.detectCloseInterval);
              setTimeout(() => {
                this.getUserCCInfo();
              }, 3000)
            }
          }, 500);
        }
      }
    },
    leave(to) {
      this.isAbort = false;
      this.isSubmit = false;
      this.$router.push({
        name: to.name
      }).catch(error => { })
    }
  },
  create() {
    this.$store.dispatch("setOverlayLoading", true);
  },
  beforeMount() {
    this.init();
  },
  beforeDestroy() {
    this.setRecaptchaStatus("");
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSubmit && !this.isAbort) {
      next(false)
      this.isAbort = true
      alert(this.$t('lottery_leave_payment'));
      this.abortController.abort();
      this.leave(to)
      return false;
    }
    next()
  }
};
</script>

<style lang="scss" scoped>
::v-deep.rwd-padding {
  padding: 0;

  @media screen and (min-width: 1024px) {

    [role="separator"]+div [class*='col'] {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
}

::v-deep.radioStyle {
  border-radius: 5px;
  border: 2px solid #c4c4c4;
  color: #c4c4c4;

  .v-label {
    flex-direction: row;
    align-items: center;
  }

  &:not(.v-item--active) .v-label .primary-1--text {
    color: $grey-1 !important;
  }

  .getWayAppend {
    margin-top: 0;
  }

  label,
  .mdi-radiobox-blank,
  .mdi-information-outline {
    color: #c4c4c4;
  }

  .v-input--selection-controls__input {
    margin-right: 12px;
  }

  &.v-item--active {
    border: 2px solid $primary-dark;

    label {
      color: #444;
    }

    .getWayName,
    .getWayAppend {
      font-weight: 500;
    }

    .getWayAppend,
    .mdi-information-outline {
      color: $primary-1;
    }
  }

  @media screen and (max-width: 600px) {

    .v-label,
    .v-label {
      flex-direction: column;
      align-items: start;
    }

    .getWayAppend {
      align-items: start;
      margin-top: 12px;
      font-weight: 500;
    }
  }
}

.order-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 5;

  .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  .row [class*="col"] {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.is-need-value .v-radio {
  border-color: transparentize($accent-red, 0.5);
}
</style>
